"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.sliceBeforeDelimiter = sliceBeforeDelimiter;
exports.sliceFromDelimiter = sliceFromDelimiter;

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

function sliceBeforeDelimiter(fullString) {
  var delimiter = 'item';
  var delimiterIndex = (0, _indexOf.default)(fullString).call(fullString, delimiter);
  var slicedString = delimiterIndex !== -1 ? fullString.substring(0, delimiterIndex) : '';
  return slicedString;
}

function sliceFromDelimiter(fullString) {
  var delimiter = 'item';
  var delimiterIndex = (0, _indexOf.default)(fullString).call(fullString, delimiter);
  var slicedString = delimiterIndex !== -1 ? fullString.substring(delimiterIndex) : '';
  return slicedString;
}
